var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkFill = function SvgBookmarkFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M36 4H12C9.794 4 8 5.794 8 8v36l16-9.144L40 44V8c0-2.206-1.794-4-4-4"
  })));
};
export { SvgBookmarkFill as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM2IDRIMTJDOS43OTQgNCA4IDUuNzk0IDggOFY0NEwyNCAzNC44NTZMNDAgNDRWOEM0MCA1Ljc5NCAzOC4yMDYgNCAzNiA0WiIgZmlsbD0iIzkwOUE5RiIvPgo8L3N2Zz4K";